export const ICON_SIZE = 24;
export const ICON_SMALL_SIZE = 18;
